module.exports = __webpack_public_path__ + "static/media/logo.4026557f.png";